import {gql} from 'apollo-angular';
import {baseResponse} from 'src/app/store/base.graphql';

export const formFieldOptionFields = `
    id
    uniqueId
    name
    value
    isActive
    createdAt
`;

export const CITIZEN_GET_FIELD_OPTIONS = gql`
    query CitizenGetFormFieldOptions($fieldUniqueId: String) {
        citizenGetFormFieldOptions(fieldUniqueId: $fieldUniqueId) {
            response {
                ${baseResponse}
            }
            data {
                ${formFieldOptionFields}
            }
        }
    }
`;
